module.exports = __webpack_public_path__ + "images/4d4323bc.jpg";